module.exports = __webpack_public_path__ + "static/media/image_12.62fbe95f.png";